interface IBackendConfig {
  jiraConfig: IBackendJiraConfig;
}

interface IBackendJiraConfig {
  projectKey: string;
  prefix: string;
  statusPrefix: string;
  issueTypeName: string;
  requestTypeName: string;
  fields: IJiraFieldsConfig;
}

interface IJiraFieldsConfig {
    addressableRegion: string;
    addressableVersion: string;
    affectedEIMs: string;
    buildVersion: string;
    fbItemLink: string;
    issueCategory: string;
    productionRound: string;
    raisedRound: string;
    reviewDueDate: string;
    reviewRegion: string;
    reviewSubmarket: string;
    vehicleModel: string;
    vehicleYear: string;
}

const EmptyJiraConfig: IBackendJiraConfig = {
  projectKey: '',
  prefix: '',
  statusPrefix: '',
  issueTypeName: '',
  requestTypeName: '',
  fields: {
    addressableRegion: '',
    addressableVersion: '',
    affectedEIMs: '',
    buildVersion: '',
    fbItemLink: '',
    issueCategory: '',
    productionRound: '',
    raisedRound: '',
    reviewDueDate: '',
    reviewRegion: '',
    reviewSubmarket: '',
    vehicleModel: '',
    vehicleYear: '',
  },
};

export type { IBackendConfig, IBackendJiraConfig };

export { EmptyJiraConfig }
